import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import CrownIcon from '@flipster/react/icon/generated/CrownIcon';
import { Styles, css } from '@flipster/styled-system/css';
import { vstack } from '@flipster/styled-system/patterns';

import { intervalInfos } from '../../shared/constants';
import { rankShareBunja } from './bunja';

interface NotRankedYetProps {
  onClose: () => void;
  css: Styles;
}

export const NotRankedYet = ({ onClose, css: cssProps }: NotRankedYetProps) => {
  const t = useTranslations();
  const { intervalAtom } = useBunja(rankShareBunja);
  const interval = useAtomValue(intervalAtom);

  return (
    <div
      className={css(
        vstack.raw({
          gap: 16,
          py: 48,
          px: 32,
        }),
        cssProps,
      )}
    >
      <div className={vstack({ gap: 12, px: 40 })}>
        <CrownIcon size={40} />
        <div className={vstack({ gap: 4 })}>
          <p
            className={css({
              textStyle: 'Text/L/Strong',
              color: 'content.default.level-5',
              textAlign: 'center',
            })}
          >
            <FormattedMessage id='Autogen_common.r251126.s_You_re_not_ranked_yet' />
          </p>
          <p
            className={css({
              textStyle: 'Text/M/Regular',
              color: 'content.default.level-2',
              textAlign: 'center',
            })}
          >
            <FormattedMessage
              id='Autogen_common.r251126.s_Make_a_trade_this_intervalInfos_interval_label_to_rank'
              values={{
                intervalInfos_interval_label: intervalInfos[interval].label,
              }}
            />
          </p>
        </div>
      </div>
      <Button
        as='a'
        hierarchy='primary'
        color='accent'
        size='small'
        label={t('Autogen_common.r251126.s_Trade_now')}
        href='/trade/perpetual/latest'
        onClick={onClose}
      />
    </div>
  );
};
